import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dash-panel" }
const _hoisted_2 = { class: "dash-panel-head" }
const _hoisted_3 = { class: "lm-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 2,
  class: "dash-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "dash-eyebrow" }, "Tendance"),
        _createElementVNode("h3", { class: "dash-panel-title" }, "12 derniers mois"),
        _createElementVNode("p", { class: "dash-panel-sub" }, "Colis livrés, en cours et retournés par mois")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.auth.can('EXPORT_DASH'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-sm btn-outline-success",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportData && _ctx.exportData(...args)))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", {
                class: "ph ph-file-xls",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Excel ", -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["ui-icon-btn lm-refresh", { spinning: _ctx.isLoader }]),
          type: "button",
          "aria-label": "Actualiser",
          title: "Actualiser",
          disabled: _ctx.isLoader,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchData && _ctx.searchData(...args)))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", {
            class: "ph ph-arrows-clockwise",
            "aria-hidden": "true"
          }, null, -1)
        ]), 10, _hoisted_4)
      ])
    ]),
    (_ctx.isLoader && !_ctx.show)
      ? (_openBlock(), _createBlock(_component_AppLoader, {
          key: 0,
          label: "Chargement des 12 derniers mois…"
        }))
      : (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["chart", { 'is-refreshing': _ctx.isLoader }])
          }, [
            _createVNode(_component_apexchart, {
              type: "bar",
              height: "340",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"])
          ], 2))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[5] || (_cache[5] = [
            _createElementVNode("i", {
              class: "ph ph-chart-bar",
              "aria-hidden": "true"
            }, null, -1),
            _createElementVNode("p", null, "Statistiques indisponibles pour le moment.", -1)
          ])))
  ]))
}